import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  reviews: [],
  processing: false,
  processingGetMore: false,
  pagination: {},
};

const getAllReviewsInstructorSlice = createSlice({
  name: "getAllReviewsInstructor",
  initialState,
  reducers: {
    pending(state) {
      state.processing = true;
      state.reviews = [];
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
      state.pagination = action.payload.pagination || {};
      state.reviews = action.payload.data.data || [];
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    getMore(state) {
      state.processingGetMore = true;
      /* TODO: reducer for pending*/
    },
    getMoreSuccess(state, action) {
      state.processingGetMore = false;
      state.reviews = [...state.reviews, ...(action.payload.data.data || [])];
      state.pagination = action.payload.pagination || {};
    },
  },
});

const { name, actions, reducer } = getAllReviewsInstructorSlice;
const getAllReviewsInstructorAction = createAction(name);
const getMoreReviewsInstructorAction = actions.getMore;

export {
  getAllReviewsInstructorAction,
  getMoreReviewsInstructorAction,
  actions as getAllReviewsInstructorActions,
  reducer as getAllReviewsInstructorReducer,
};
